"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var bolt_protocol_v4x2_1 = __importDefault(require("./bolt-protocol-v4x2"));
var request_message_1 = __importDefault(require("./request-message"));
var stream_observers_1 = require("./stream-observers");
var stream_observers_2 = require("./stream-observers");
var neo4j_driver_core_1 = require("neo4j-driver-core");
var Bookmark = neo4j_driver_core_1.internal.bookmark.Bookmark,
  BOLT_PROTOCOL_V4_3 = neo4j_driver_core_1.internal.constants.BOLT_PROTOCOL_V4_3;
var BoltProtocol = /** @class */function (_super) {
  __extends(BoltProtocol, _super);
  function BoltProtocol() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(BoltProtocol.prototype, "version", {
    get: function get() {
      return BOLT_PROTOCOL_V4_3;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Request routing information
   *
   * @param {Object} param -
   * @param {object} param.routingContext The routing context used to define the routing table.
   *  Multi-datacenter deployments is one of its use cases
   * @param {string} param.databaseName The database name
   * @param {Bookmark} params.sessionContext.bookmark The bookmark used for request the routing table
   * @param {function(err: Error)} param.onError
   * @param {function(RawRoutingTable)} param.onCompleted
   * @returns {RouteObserver} the route observer
   */
  BoltProtocol.prototype.requestRoutingInformation = function (_a) {
    var _b = _a.routingContext,
      routingContext = _b === void 0 ? {} : _b,
      _c = _a.databaseName,
      databaseName = _c === void 0 ? null : _c,
      _d = _a.sessionContext,
      sessionContext = _d === void 0 ? {} : _d,
      onError = _a.onError,
      onCompleted = _a.onCompleted;
    var observer = new stream_observers_1.RouteObserver({
      onProtocolError: this._onProtocolError,
      onError: onError,
      onCompleted: onCompleted
    });
    var bookmark = sessionContext.bookmark || Bookmark.empty();
    this.write(request_message_1.default.route(routingContext, bookmark.values(), databaseName), observer, true);
    return observer;
  };
  /**
   * Initialize a connection with the server
   *
   * @param {Object} param0 The params
   * @param {string} param0.userAgent The user agent
   * @param {any} param0.authToken The auth token
   * @param {function(error)} param0.onError On error callback
   * @param {function(onComplte)} param0.onComplete On complete callback
   * @returns {LoginObserver} The Login observer
   */
  BoltProtocol.prototype.initialize = function (_a) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a,
      userAgent = _b.userAgent,
      authToken = _b.authToken,
      _onError = _b.onError,
      onComplete = _b.onComplete;
    var observer = new stream_observers_2.LoginObserver({
      onError: function onError(error) {
        return _this._onLoginError(error, _onError);
      },
      onCompleted: function onCompleted(metadata) {
        if (metadata.patch_bolt !== undefined) {
          _this._applyPatches(metadata.patch_bolt);
        }
        return _this._onLoginCompleted(metadata, onComplete);
      }
    });
    this.write(request_message_1.default.hello(userAgent, authToken, this._serversideRouting, ['utc']), observer, true);
    return observer;
  };
  /**
   *
   * @param {string[]} patches Patches to be applied to the protocol
   */
  BoltProtocol.prototype._applyPatches = function (patches) {
    if (patches.includes('utc')) {
      this._applyUtcPatch();
    }
  };
  BoltProtocol.prototype._applyUtcPatch = function () {
    this._packer.useUtc = true;
    this._unpacker.useUtc = true;
  };
  return BoltProtocol;
}(bolt_protocol_v4x2_1.default);
exports.default = BoltProtocol;